/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Rail_Page_BodyInputs */

const en_platform_rail_page_body = /** @type {(inputs: Platform_Rail_Page_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A page at your own address that clients book from without calling.`)
};

const pl_platform_rail_page_body = /** @type {(inputs: Platform_Rail_Page_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strona pod Twoim adresem, z której podopieczni rezerwują bez dzwonienia.`)
};

/**
* | output |
* | --- |
* | "A page at your own address that clients book from without calling." |
*
* @param {Platform_Rail_Page_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_rail_page_body = /** @type {((inputs?: Platform_Rail_Page_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Rail_Page_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_rail_page_body(inputs)
	return en_platform_rail_page_body(inputs)
});